import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { ThemeProvider } from "./context/ThemeContext";
import { AuthProvider, useAuth } from "./context/AuthContext";

// Auth components
import LoginPage from "./pages/auth/Login";

// Admin components
import AdminLayout from "./components/admin/AdminLayout";
import AdminDashboard from "./pages/admin/Dashboard";
import NichesPage from "./pages/admin/Niches";
import ProductsPage from "./pages/admin/Products";
import ContentPage from "./pages/admin/Content";
import ScraperPage from "./pages/admin/Scraper";
import AnalyticsPage from "./pages/admin/Analytics";

// Public components
import PublicLayout from "./components/public/PublicLayout";
import PublicHomePage from "./pages/public/HomePage";
import NicheComparison from "./pages/public/NicheComparison";
import ProductReview from "./pages/public/ProductReview";

// Protected Route wrapper
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
        <div className="text-white">Loading...</div>
      </div>
    );
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      {/* Auth Routes */}
      <Route path="/login" element={<LoginPage />} />

      {/* Admin Routes - Protected */}
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<AdminDashboard />} />
        <Route path="niches" element={<NichesPage />} />
        <Route path="products" element={<ProductsPage />} />
        <Route path="content" element={<ContentPage />} />
        <Route path="scraper" element={<ScraperPage />} />
        <Route path="analytics" element={<AnalyticsPage />} />
      </Route>

      {/* Public Routes */}
      <Route path="/" element={<PublicLayout />}>
        <Route index element={<PublicHomePage />} />
        <Route path="products/:slug" element={<ProductReview />} />
        <Route path=":slug" element={<NicheComparison />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Toaster 
          position="top-right" 
          richColors 
          toastOptions={{
            style: { background: '#1A1A1A', border: '1px solid #2A2A2A' },
          }}
        />
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
